import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
/**
 * Die `AppConfigService`-Klasse dient dem Laden und Bereitstellen
 * von anwendungsweiten Konfigurationseinstellungen aus der Datei
 * `app.config.json`, die sich im Verzeichnis `/assets/` befindet.
 *
 * BEGRÜNDUNG:
 * Es gibt keine AFO
 */
export class AppConfigService {
  private config: AppConfig | null = null;

  private readonly http = inject(HttpClient);

  async load(): Promise<void> {
    this.config = await firstValueFrom(this.http.get<AppConfig>('/assets/app.config.json'));
  }

  get(key: keyof AppConfig): string {
    if (!this.config) {
      return '';
    }
    return this.config[key];
  }
}

export interface AppConfig {
  homeserverHostname: string;
  authorityUrl: string;
  regDienstUrl: string;
  vzdFhirUrl: string;
  keycloakUsersUrl: string;
  isTesttreiberEnabled: string;
  testtreiberHomeserverHostname: string;
  testtreiberPort: string;
  testtreiberOrgAdminPort: string;
  testtreiberClientUrl: string;
  testtreiberUsersProClient: string;
  testtreiberUsersOrgAdmin: string;
  testtreiberOtpEndpointEnabled: string;
  userEmailDomain: string;
  encodeMxid: string;
  useSameOriginProxy: string;
  useFhirMock: string;
  fhirProxyMockBase: string;
  fhirProxyRealBase: string;
  idpBaseUrl: string;
  idpRealm: string;
  idpClient: string;
  fachdienstVersion: string;
  fachdienstOsName: string;
  fachdienstOsVersion: string;
  testDriverVersion: string;
  enableV2Room: string;
  mailpitUrl: string;
  useWhitelist: string;
  enableNutzerverwaltung: string;
}
